/** Documents, missing documents and payslip texts (English). Missing keys fall back to Turkish. */
export const documents = {
  category: {
    identity: "Identity and residence",
    education: "Education",
    health: "Health",
    contract: "Contracts and legal",
    payroll: "Payroll and bank",
    certificate: "Certificates",
    other: "Other",
  },
  sensitivity: {
    normal: "Standard",
    special: "Special category",
    specialHint: "Special category personal data. Only the employee and authorised HR can see it; every access is logged.",
  },
  status: {
    pending_review: "In review",
    accepted: "Accepted",
    rejected: "Rejected",
    archived: "Archived",
  },
  expiry: {
    expired: "Expired",
    expiring: "Expiring soon",
    validUntil: "Valid until {date}",
  },
  request: {
    status: { open: "Waiting", fulfilled: "Uploaded", cancelled: "Cancelled" },
    due: "Due {date}.",
    overdue: "Overdue",
  },
  missing: {
    reason: {
      required: "Required from everyone",
      requested: "Requested by HR",
      expired: "Expired, a new one is needed",
    },
    state: {
      missing: "Not uploaded yet",
      in_review: "Uploaded, HR is reviewing",
      rejected: "Rejected, please upload again",
    },
    emptyMine: "Nothing is requested from you. You're all set.",
    emptyAll: "No missing documents.",
  },
  review: {
    accept: "Accept",
    reject: "Reject",
    rejectNoteHint: "Explain what is missing; the employee will see this note.",
  },
  notify: {
    specialType: "A special category document",
    detailsInApp: "See the details in the app.",
  },
  retention:
    "Documents are archived, not deleted. Archived documents are kept for the legal retention period, visible only to authorised HR, and securely destroyed afterwards.",
  errors: {
    no_employee_record: "Your account isn't linked to an employee record. Ask your HR team to link it.",
    type_not_uploadable: "You can't upload this document type yourself. Send it to HR; you can upload it here once HR requests it.",
    type_archived: "This document type is no longer used. Choose another type.",
    file_invalid: "The file was not found or is attached to another record. Upload it again and retry.",
    expiry_required: "Enter the expiry date for this document type.",
    already_reviewed: "This document has already been reviewed. Refresh to see its current status.",
    archived: "Archived documents can't be changed.",
    special_requires_permission: "You don't have access to special category documents. Contact your HR manager.",
    request_exists: "This document has already been requested from this employee. Use the existing request or cancel it first.",
    request_closed: "This request is already closed.",
    employee_terminated: "Documents can't be requested from a former employee.",
    duplicate_type: "A document type with this name already exists. Choose another name.",
    already_published: "A published payslip can't be changed. Upload a new file; it will replace the old one.",
    replaced: "A newer payslip has replaced this one.",
  },
  payslip: {
    defaultTitle: "{period} payslips",
    batchStatus: { draft: "Draft", published: "Published" },
    matchedBy: {
      employee_number: "Matched by employee number",
      national_id: "Matched by national ID",
      manual: "Matched manually",
      unmatched: "Not matched",
      replaced: "Replaced by a newer file",
    },
    unmatchedReason: {
      no_identifier: "The file name has no employee number or national ID. Choose the employee manually.",
      not_found: "The number in the file name matches no employee. Check the employee's number or national ID, or match manually.",
      ambiguous: "The file name matches more than one employee. Choose the right one manually.",
    },
    rejected: {
      not_found: "File not found. Upload it again as a payslip file.",
      not_pdf: "Payslips must be PDF files.",
      already_attached: "This file is already attached to a payslip.",
    },
    publishConfirm_one: "{count} employee will get their payslip and a notification.",
    publishConfirm_other: "{count} employees will get their payslips and a notification.",
    unmatchedWarning_one: "{count} file is not matched and won't be published.",
    unmatchedWarning_other: "{count} files are not matched and won't be published.",
    acknowledge: "I received it",
    acknowledgedOn: "Received on {date}",
    viewed: "Viewed",
    notViewed: "Not opened yet",
    empty: "No payslips have been published for you yet.",
    privacy: "Only you and the people responsible for payroll can see your payslip; every access is logged.",
  },
};
